import React, { useState, useEffect } from 'react';
import './Dashhome.css';
import { ReactComponent as Facebook } from '../assets/planetsystem/Facebook Icon.svg';
import { ReactComponent as Instagram } from '../assets/planetsystem/Instagram Icon.svg';
import { ReactComponent as Twitter } from '../assets/planetsystem/Twitter icon.svg';
import { ReactComponent as Youtube } from '../assets/planetsystem/Youtube Icon.svg';
import { ReactComponent as Whatsapp } from '../assets/planetsystem/Whatsapp Icon.svg';
import { ReactComponent as Snapchat } from '../assets/planetsystem/Snapchat Icon.svg';
import { Treemeter } from './pages/meters/Treemeter';
import { Meterco2 } from './pages/meters/Meterco2';
import { Meteroxygen } from './pages/meters/Meteroxygen';
import ENV from '../constants/env-constants';
import { useLocation } from 'react-router-dom';
import ReactGA from "react-ga4";
import { Helmet } from 'react-helmet';
import { formatNumbers } from '../utils/formatNumbers';
import { getUserDetails } from '../utils/api';
import { SocialIcon } from 'react-social-icons/component'
import 'react-social-icons/facebook'
import 'react-social-icons/x'
import { XIcon } from '../components/SocialMediaIcon';

function Dashhome() {
  const userid = localStorage.getItem('userid');
  const [userDetails, setUserDetails] = useState({});
  const [transactions, setTransactions] = useState([]);

  const location = useLocation();
  useEffect(() => {
  ReactGA.send({ hitType: "pageview", page: location.pathname, title: 'Dashboard Landing Page' });
    const fetchUserDetails = async () => {
      const data = await getUserDetails(userid)
      // console.log(data)
      setUserDetails(data);
    };

    const fetchTransactions = async () => {
      const response = await fetch(`${ENV.API_URL}/api/transactions/${userid}`);
      const data = await response.json();
      // console.log(data)
      setTransactions(data);
    };

    fetchUserDetails();
    fetchTransactions();
  }, []);


  const co2Absorbed = userDetails.totalDonated || userDetails.numberOfFreeTrees ? ((userDetails.totalDonated + userDetails.numberOfFreeTrees) * 0.675).toFixed(2) : 0;
  const oxygenReleased = userDetails.totalDonated || userDetails.numberOfFreeTrees ? ((userDetails.totalDonated +  + userDetails.numberOfFreeTrees) * 0.675 * 2.67).toFixed(2) : 0;

  return (
    <div className={`layout-page layout-page-custom`}>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Dashboard</title>
      </Helmet>
      {/* Navbar */}
      <nav className="layout-navbar container-xxl navbar navbar-expand-xl navbar-detached align-items-center bg-navbar-theme layout-navbarcustom pt-0" id="layout-navbar">
        {/* <div className="layout-menu-toggle navbar-nav align-items-xl-center me-3 me-xl-0 d-xl-none">
          <a className="nav-item nav-link px-0 me-xl-4">
            <i className="bx bx-menu bx-sm" />
          </a>
        </div> */}
        <div className="navbar-nav-right d-flex align-items-center" id="navbar-collapse">
          {/* Search */}
          <div className="navbar-nav">
            <div className="nav-item navbar-navitemcustom">
              {/* <i className="bx bx-search fs-4 lh-0" />
              <input type="text" className="form-control border-0 shadow-none ps-1 ps-sm-2" placeholder="Search..." aria-label="Search..." /> */}

              <h3><div style={{color:'#005A92', display: 'inline-block'}}>Welcome back,  </div><div style={{color:'green', display: 'inline-block'}}>&nbsp;{userDetails.name}</div> <div style={{fontSize:'15px'}}>Member since {userDetails.createdAt ? new Date(userDetails.createdAt).toLocaleDateString() : " "}</div></h3>            
            </div>
          </div>
          {/* /Search */}
          <ul className="navbar-nav flex-row align-items-center ms-auto">

            {/* User */}
            <li className="nav-ite" style={{margin:'15px',paddingTop:'0'}}>
              <a className="nav-lin">
                <div className="avatar avatar-online">
                  <img src="../assets/img/avatars/person.png" alt="" className="w-px-40 h-auto rounded-circle" />
                </div>
              </a>
              
            </li>
            {/*/ User */}
            <li className="nav-item lh-1 me-3" style={{paddingTop:'15px'}}>
              {/* <a className="github-button" href="https://github.com/themeselection/sneat-html-admin-template-free" data-icon="octicon-star" data-size="large" data-show-count="true" aria-label="Star themeselection/sneat-html-admin-template-free on GitHub">Star</a> */}
              <h6>{userDetails.name}</h6>
              <p>{userDetails.email}</p>
            </li>
          </ul>
        </div>
      </nav>
      {/* / Navbar */}
      
      {/* Content wrapper */}
      <div className="content-wrapper content-wrapper-custom">
        {/* Content */}
        
        <div className="container-xxl flex-grow-1 container-p-y">
          <div className="row">
            <div className="col-lg-12 mb-4 order-0">
              <div className="card cardbackgroundforest" style={{transform:'none', boxShadow:'none'}}>
                <div className="row card-bodyheading">
                  <h2 style={{color:'white'}}>Timms forest</h2>
                </div>
                <div className="d-flex align-items-end row">
                  <div className="col text-center text-sm-left">
                    <div className="card-body pb-0 px-0 px-md-4 card-bodycustom">
                      <Treemeter  numberOfTrees={userDetails.totalDonated}/>
                      <h3 className='customheadingmeters'>{formatNumbers(userDetails.totalDonated + userDetails.numberOfFreeTrees)} Trees</h3>
                      <p className='customheadingmeters1'>Trees planted</p>
                    </div>
                  </div>
                  <div className="col text-center text-sm-left">
                    <div className="card-body pb-0 px-0 px-md-4 card-bodycustom">
                      <Meterco2 className="custommeter" co2Absorbed={co2Absorbed}/>
                      <h3 className='customheadingmeters'>Co<sub>2</sub> Absorbed</h3>
                      <p className='customheadingmeters1'>{ co2Absorbed > 1 ? formatNumbers(co2Absorbed) : co2Absorbed} Pounds Per Year</p>
                    </div>
                  </div>
                  <div className="col text-center text-sm-left">
                    <div className="card-body pb-0 px-0 px-md-4 card-bodycustom">
                      <Meteroxygen oxygenReleased={oxygenReleased}/>
                      <h3 className='customheadingmeters'>Oxygen Released</h3>
                      <p className='customheadingmeters1'>{oxygenReleased > 1 ? formatNumbers(oxygenReleased) : oxygenReleased} Pounds Per Year</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-12 col-md-4 order-1">
              <div className="row">
                <div className="col-lg-7 col-md-12 col-6 mb-4">
                  <div className="card customcard1" style={{overflow: 'visible', transform:'none', boxShadow:'none'}}>
                    <div className="card-body">
                      <div className="card-title card-title-custom d-flex align-items-start justify-content-between">
                        <div className="cardheadingcustom">Last Donation</div>
                      </div>
                      <div className='row'>
                        <div className='col'>
                          <h5 className="fw-medium fontcolorcustom1">Date</h5>
                          <h3 className="card-title card-title-custom" style={{color:'#549545'}}>
                            {userDetails.latestTransaction ? new Date(userDetails.latestTransaction.createdAt).toLocaleDateString() : "Not yet donated"}
                          </h3>
                        </div>
                        <div className='col'>
                          <h5 className="fw-medium fontcolorcustom1">Amount</h5>
                          <h3 className="card-title card-title-custom" style={{color:'#549545'}}>
                            ${userDetails.latestTransaction ? formatNumbers(userDetails.latestTransaction.amount) : "0"}
                          </h3>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-5 col-md-12 col-6 mb-4">
                  <div className="card customcard1" style={{overflow: 'visible', transform:'none', boxShadow:'none'}}>
                    <div className="card-body"  style={{display:'flex', alignItems:'center'}}>
                      <div className="card-title card-title-custom d-flex align-items-start justify-content-between">
                        <div className="cardheadingcustom1">Share With</div>
                      </div>
                      <div className='row colcustom'>
                        {/* <div className='col-2 '><Facebook /></div>
                        <div className='col-2 '><Instagram /></div>
                        <div className='col-2 '><Twitter /></div>
                        <div className='col-2 '><Youtube /></div> */}
                        { /* <div style={{ marginLeft: "0.3rem" }} className='col-2 '><SocialIcon style={{ height: '40px', width: '40px' }} bgColor='#005A92' network='facebook' url="www.facebook.com" /></div> */}
                        {/* <div style={{ marginLeft: "0.3rem" }} className='col-2 '><SocialIcon style={{ height: '40px', width: '40px' }} bgColor='#005A92' url="www.instagram.com" /></div> */}
                        <div style={{ marginLeft: "0.3rem" }} className='col-2 '>{<XIcon />}</div>
                        {/* <div style={{ marginLeft: "0.3rem" }} className='col-2 '><SocialIcon style={{ height: '40px', width: '40px' }} bgColor='#005A92' url="www.x.com" /></div> */}
                        {/* <div style={{ marginLeft: "0.3rem" }} className='col-2 '><SocialIcon style={{ height: '40px', width: '40px' }} bgColor='#005A92' url="www.x.com" /></div> */}
                        {/* <div className='col-2 '><Whatsapp /></div> */}
                        {/* <div className='col-2 '><Snapchat /></div> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row" style={{height: "10rem"}}>
            <div className="card" style={{transform:'none', boxShadow:'none'}}>
              <div className="table-responsive text-nowrap">
                <table className="table">
                  <thead>
                    <tr>
                      <th>Transaction ID</th>
                      <th>Transaction Date</th>
                      <th>Amount</th>
                      <th>Trees</th>
                    </tr>
                  </thead>
                  <tbody className="table-border-bottom-0">
                    {/* filter is added to remove transactions with 0 dollars. */}
                    {/* Why 0 dollars transaction exists? Ans: These are generally added in transactions to add free trees recievers, even though they haven't spend money but the tree is planted on their behalf so it will be like 1 tree for 0 dollars */}
                    {transactions.filter((transaction)=> Boolean(transaction.amount)).map((transaction) => (
                      <tr key={transaction.tid}>
                        <td>{transaction.tid}</td>
                        <td>{new Date(transaction.createdAt).toLocaleDateString()}</td>
                        <td>${formatNumbers(transaction.amount)}</td>
                        <td>{formatNumbers(transaction.amount)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        {/* / Content */}
        <div className="content-backdrop fade"></div>
      </div>
      {/* / Content wrapper */}
    </div>
  );
}

export default Dashhome;
